<template lang="">
  <div id="content">
	<div class="global_area">
	  <div class="path"><a href="#none">Home</a> &gt; <a href="#none">공지사항 관리</a> &gt; <strong>공지사항 리스트</strong></div>
	  <h2 class="h_sub">공지사항 리스트</h2>
	</div>
    
    <BoardNoticeManageListForm/>
  </div>
</template>

<script>
import BoardNoticeManageListForm from '@/components/admin/board/BoardNoticeManageListForm.vue';

export default {
  components: {
	  BoardNoticeManageListForm
  }
}
</script>
<style lang="">
    
</style>